var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-full overflow-hidden",class:{
    'all:inline-flex align-center justify-center bg-purple-800 font-bold':
      !_vm.src || _vm.imageLoadFailed,
  },style:(`height: ${_vm.size}px; width: ${_vm.size}px`)},[(_vm.src && !_vm.imageLoadFailed)?_c('img',{attrs:{"src":_vm.companySetting.logo?.url,"alt":_vm.$t('altText.companyLogo')},on:{"error":function($event){_vm.imageLoadFailed = true}}}):_c('i',{staticClass:"text-18 text-white",class:_vm.Icon.IndustryWindows})])
}
var staticRenderFns = []

export { render, staticRenderFns }